import React, { type ComponentProps } from 'react';

import Button from '@adsk/alloy-react-button';
import { ChevronDownIcon, ChevronUpIcon } from '@adsk/alloy-react-icon';

import type { ButtonTemplateProps } from '../../types';

type DropdownButtonProps = ButtonTemplateProps & {
  variant?: ComponentProps<typeof Button>['variant'];
};

const DropdownButtonControl = ({
  targetProps,
  show,
  handleToggle,
  onClick,
  children,
  ...props
}: DropdownButtonProps) => (
  <Button
    ref={targetProps.ref}
    renderRightIcon={(p) =>
      show ? <ChevronUpIcon {...p} /> : <ChevronDownIcon {...p} />
    }
    onClick={(...args) => {
      onClick?.(...args);
      handleToggle();
    }}
    {...props}
  >
    {children}
  </Button>
);

export default DropdownButtonControl;
